import React from 'react'
import propTypes from 'prop-types'
import {Box} from '@chakra-ui/react'

const LogoBecs = ({width, height, ...props}) => (
  <Box
    as="svg"
    width={width}
    height={height}
    viewBox="0 0 50 32"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="nonzero"
    data-testid="logo-becs"
    {...props}
  >
    <g transform="translate(0, 0)" fill="#000000">
      <g id="Becs" transform="translate(0.000000, -0.000000)">
        <g id="BG">
          <rect fill="#fff" y="0" width="50" height="32" rx="4" ry="4" />
        </g>
        <g id="LOGOS">
          <g>
            <path d="m11.93,15.46c1.07.6,1.83,1.43,2.21,2.55.87,2.59-.18,6.46-4.34,6.81-1.91.16-3.84.03-5.8.03V7.03c2.14.07,4.28-.03,6.36.27,2.68.38,4.32,3.01,3.7,5.53-.29,1.17-1.03,2-2.12,2.63Zm-4.53,1.62v4.94c1.21.07,2.37.11,3.1-1.01.6-.92.59-1.91.03-2.85-.72-1.19-1.89-1.16-3.13-1.08Zm-.02-2.88c1.13.05,2.25.21,2.97-.9.49-.75.51-1.58.04-2.35-.71-1.15-1.85-1.03-3.01-.97v4.22Z" />
            <path d="m35.44,17.47c-.12,1.98-.46,3.8-1.5,5.44-1.94,3.07-7.01,3.12-8.86-.51-.85-1.66-1.16-3.43-1.25-5.26-.12-2.38.03-4.74,1.04-6.94,1.3-2.82,4.23-4.04,6.98-2.97.87.34,1.55.91,2.07,1.66,1.12,1.63,1.4,3.49,1.52,5.46h-3.42c-.12-.75-.2-1.47-.36-2.16-.12-.51-.29-1.02-.54-1.47-.61-1.1-1.85-1.22-2.56-.19-.45.67-.8,1.47-.96,2.26-.47,2.34-.48,4.7.1,7.03.14.54.36,1.08.66,1.56.69,1.11,2.07,1.16,2.64-.02.48-1,.7-2.14.89-3.25.1-.55.26-.68.77-.66.91.04,1.83.01,2.79.01Z" />
            <path d="m42.78,12.57c-.16-.64-.23-1.26-.46-1.82-.38-.97-1.25-1.37-2.03-1.03-.83.37-1.29,1.51-.76,2.34.46.71,1.13,1.31,1.79,1.86.77.64,1.67,1.12,2.46,1.74,1.69,1.32,2.37,3.09,2.18,5.21-.2,2.36-2.23,4.16-4.75,4.21-3.43.07-5.6-2.18-5.39-5.64.01-.17.18-.46.28-.47.98-.04,1.96-.02,2.92-.02.08.75.09,1.41.23,2.04.24,1.04.96,1.5,1.98,1.36.86-.11,1.34-.76,1.36-1.8.02-1.24-.72-2.03-1.62-2.7-.86-.64-1.79-1.19-2.63-1.85-1.25-.99-2.21-2.19-2.36-3.86-.26-2.96,1.98-5.3,5.03-5.28,3.15.02,5.33,2.56,4.86,5.7h-3.11Z" />
            <path d="m15.21,7.13h8.23v2.95h-4.78v4.36h4.52v3.03h-4.53v4.42h4.82c0,.96.01,1.84-.02,2.73,0,.11-.26.29-.39.29-2.6.02-5.2.01-7.85.01V7.13Z" />
          </g>
        </g>
      </g>
    </g>
  </Box>
)

LogoBecs.defaultProps = {
  width: 188,
  height: 148,
}

LogoBecs.propTypes = {
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  height: propTypes.oneOfType([propTypes.number, propTypes.string]),
}

export default LogoBecs
